import { useCanvasContext } from '../hooks/useCanvas';
import { useResponsiveSize } from '../hooks/useResponsiveSize';
import { WaveObj } from '../utils/WaveObj';

const WAVE_HEIGHT = 600;

export const Wave = (): null => {
    const { context } = useCanvasContext();
    const { width } = useResponsiveSize();

    let frequency = 0.013;
    const waves = {
        frontWave: new WaveObj([0.0211, 0.028, 0.015], 'rgb(236, 71, 85, 0.1)'),
        backWave: new WaveObj([0.0122, 0.018, 0.005], 'rgb(249, 168, 168, 0.1)'),
    };

    const render = (): void => {
        context?.clearRect(0, 0, width, WAVE_HEIGHT);
        Object.entries(waves).forEach(([, wave]) => {
            context && wave.draw(context, width, WAVE_HEIGHT, frequency);
        });

        frequency += 0.013;
        requestAnimationFrame(render);
    };

    if (context) {
        render();
    }

    return null;
};
